import {Component, Input} from '@angular/core';
import {filter, Subject, takeUntil} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../state/app.state";
import {CommonService} from "../../../../shared/services/common.service";
import {
  roles,
  sortOrderMap
} from "../../../../shared/constants/common.constants";
import {
  FetchResourceListRequest,
  FetchWeekSummaryRequest
} from "../../core/behavior-tracker.actions";
import {resourceList, weekSummary} from "../../core/behavior-tracker.selectors";
import * as _ from "lodash";
import {SetWeekInfoForContract} from "../../../../shared/core/shared.actions";
import {
  profile,
  selectedUserProfile
} from "../../../../shared/core/shared.selectors";
import moment from 'moment';
import {BehaviourTrackerService} from '../../service/behaviour-tracker.service';
import {
  ResourcesResponse
} from '../../../resources-hub/model/resource-details.model';

@Component({
  selector: 'app-behavior-tracker-details-screen',
  templateUrl: './details-screen.component.html',
  styleUrls: ['./details-screen.component.css']
})
export class BehaviorTrackerDetailsScreenComponent {
  @Input() selectedWeekNumber = -1;
  weekSummary: any = {};
  weekSummaryLoader: boolean = false;
  myResources = [];
  role: number;
  selectedUserRole: number;
  displayContractBtn: boolean = true;
  weekNumber: number;
  groupId: number;
  selectedUserGroupId: number;
  memberId: number;
  weeklyRlPointSum: number = null;
  weeklyRlGoal: number = 0;
  weeklyStGoal: number = 0;
  weeklyPaGoal: number = 0;
  weeklyPaGoalDays: number = 0;
  weeklyStPointSum: number = 0;
  weeklyPaPointSum: number = 0;
  weeklyPaGoalMetDays: number = null;
  previousUrl: string;
  components = {
    weightChart: 1,
    heightChart: 2,
    redLightFoodChart: 3,
    physicalActivityChart: 4,
    screenTimeChart: 5,
    journalingChart: 6,
    bmiChart: 7
  }
  selectedDate: string;
  isDrillDown: boolean = false;
  private readonly onDestroy: Subject<any> = new Subject<any>();
  showDetailsForAdult = false;
  throttle = 300;
  scrollDistance = 0.01;
  scrollUpDistance = 0.01;
  paginationRelatedLoading: boolean = false;
  resourcesData: any;

  payload = {};
  selectedDateDetails: any = {};

  constructor(
    private router: Router,
    private store: Store<fromRoot.State>,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private participantService: BehaviourTrackerService
  ) {
    const params: any = this.route.snapshot.params;
    this.isDrillDown = !!(params && params?.clientAdminId ||
      params?.coachId ||
      params?.memberId);
    this.memberId = params && params?.memberId;


  }

  ngOnInit() {
    this.store.select(profile)
      .pipe(
        takeUntil(this.onDestroy),
        filter(data => !!data)
      )
      .subscribe(data => {
        this.role = data?.role
        this.groupId = this.role === roles['adult'] ? -1 : data?.groupId
        this.fetchWeekSummary();
        if (!this.memberId) {
          this.showDetailsForAdult = data?.role === roles.adult;
        }

      });

    this.store.select(selectedUserProfile)
      .pipe(
        takeUntil(this.onDestroy),
        filter(data => !!data.profile)
      )
      .subscribe(data => {
        this.selectedUserRole = data?.profile?.role
        this.selectedUserGroupId = this.selectedUserRole === roles['adult'] ? -1 : data?.profile?.groupId;
        this.fetchWeekSummary();
        if (this.memberId) {
          this.showDetailsForAdult = data?.profile?.role === roles.adult;
        }

        this.fetchResourceList({pageNumber: 1});
      });

    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe((d) => {
        this.previousUrl = d.url;
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams
        }

        this.weekNumber = Number(this.route.snapshot.queryParams['weekNumber']);
        this.memberId = Number(this.route.snapshot.params['memberId']);

        const prevUrlParams = this.commonService.urlParams.getValue();

        if (JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
          this.commonService.urlParams.next(urlParams);
        }
        this.selectedDate = null;
        this.participantService.selectedDayData.next({});
        this.fetchWeekSummary();
      });

    this.store.select(resourceList)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.resourcesData = data;
        this.myResources = data?.list
      });


    this.store.select(weekSummary)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        const tempData = _.cloneDeep(data);
        this.weekSummary = tempData?.weekSummary;
        this.weekSummaryLoader = tempData?.loading;
        this.weeklyRlPointSum = null
        this.weeklyPaPointSum = 0;
        this.weeklyPaGoalMetDays = null;
        this.weeklyStPointSum = null;

        this.weeklyRlGoal = null;
        this.weeklyPaGoal = null;
        this.weeklyPaGoalDays = null;
        this.weeklyStGoal = null;

        for (let i = 0; i < this.weekSummary['weekData']?.length; i++) {
          if (this.weekSummary['weekData'][i]['rlGoal']) {
            this.weeklyRlGoal = this.weekSummary['weekData'][0]['rlGoal']
          }

          if (this.weekSummary['weekData'][i]['paGoal']) {
            this.weeklyPaGoal = this.weekSummary['weekData'][0]['paGoal']
            this.weeklyPaGoalDays = this.weekSummary['weekData'][0]['paGoalDays']
          }

          if (this.weekSummary['weekData'][i]['stGoal']) {
            this.weeklyStGoal = this.weekSummary['weekData'][0]['stGoal']
          }

          if (this.weekSummary['weekData'][i]['fiPoints'] !== null) {
            if (this.weeklyRlPointSum === null) {
              this.weeklyRlPointSum = 0;
            }
            this.weeklyRlPointSum += this.weekSummary['weekData'][i]['fiPoints']
          }

          if (this.weekSummary['weekData'][i]['paPoints']) {
            this.weeklyPaPointSum += this.weekSummary['weekData'][i]['paPoints']
          }

          if (
            this.weekSummary['weekData'][i]['paPoints'] &&
            this.weekSummary['weekData'][i]['paGoal'] &&
            this.weekSummary['weekData'][i]['paPoints'] >= this.weekSummary['weekData'][i]['paGoal']
          ) {
            if (this.weeklyPaGoalMetDays === null) {
              this.weeklyPaGoalMetDays = 1;
            } else {
              this.weeklyPaGoalMetDays += 1;
            }
          }

          if (this.weekSummary['weekData'][i]['stPoints'] !== null) {
            if (this.weeklyStPointSum === null) {
              this.weeklyStPointSum = this.weekSummary['weekData'][i]['stPoints'];
            } else {
              this.weeklyStPointSum += this.weekSummary['weekData'][i]['stPoints']
            }
          }
        }

        if (this.weeklyPaPointSum && this.weekSummary.weekData?.[0]?.paGoal && this.weeklyPaGoalMetDays === null) {
          this.weeklyPaGoalMetDays = 0;
        }

        if (this.weekSummary['weekData']?.length) {
          let weekDay = this.weekSummary['weekData'].find((weekDay) => moment(weekDay.date)
            .isSame(moment(this.selectedDate), 'date'));
          if (!weekDay) {
            weekDay = this.weekSummary['weekData'][0];
          }
          weekDay.isSelected = true;
        }

        this.fetchResourceList();
      });


    if (this.role === roles['adult'] || this.selectedUserRole === roles['adult']) {
      this.displayContractBtn = false;
    }

    if (this.role === roles['adult'] && this.selectedUserRole === roles['participant']) {
      this.displayContractBtn = true;
    }

    this.participantService.selectedDayData
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        this.selectedDateDetails = data;
        this.selectedDate = data?.date;
      });
  }

  viewProgress(type) {

    let chart: number;
    if (type && type === 'rl') {
      chart = this.components.redLightFoodChart
    }
    if (type && type === 'pa') {
      chart = this.components.physicalActivityChart
    }
    if (type && type === 'st') {
      chart = this.components.screenTimeChart
    }
    const urlPrefix = this.router.url.split('/')[1];
    let url = `/${urlPrefix}/my-progress`
    if (this.isDrillDown && this.memberId) {
      url = `/${urlPrefix}/member/${this.memberId}/progress`
    }
    this.router.navigate([url], {
      queryParams: {
        chart
      }
    });
  }

  redirectToContracts() {
    const payload = {
      sessionNumber: this.weekSummary['lastSessionInWeek'],
      weekNumber: Number(this.route.snapshot.queryParams['weekNumber']),
      weekStartDate: this.weekSummary['startDate'],
      weekEndDate: this.weekSummary['endDate'],
      previousUrl: this.previousUrl,
    }

    this.store.dispatch(SetWeekInfoForContract(payload));

    const urlPrefix = this.router.url.split('/')[1];
    if (this.route.snapshot.params['memberId']) {
      this.router.navigate([`/${urlPrefix}/member/${this.route.snapshot.params['memberId']}/contract`]);
    } else {
      this.router.navigate([`/${urlPrefix}/contract`]);
    }
  }

  fetchWeekSummary() {
    const payload = {
      weekNumber: this.weekNumber,
      groupId: this.memberId ? this.selectedUserGroupId : this.groupId,
      ...(this.memberId ? {forUserId: this.memberId} : {})
    }

    if (this.weekNumber > 0 && payload.groupId) {
      this.store.dispatch(FetchWeekSummaryRequest({payload}));
    }
  }

  fetchResourceList(pagination?) {
    if (
      (this.route.snapshot.params['memberId'] && this.selectedUserRole) ||
      (!this.route.snapshot.params['memberId'] && this.role)
    ) {
      const role = this.route.snapshot.params['memberId'] ? [this.selectedUserRole] : [this.role];
      if (this.weekSummary && (Object.keys(this.weekSummary).length)) {
        const sessionArray = [];
        if (this.weekSummary?.sessionData?.length) {
          this.weekSummary?.sessionData?.map((session) => {
            sessionArray.push(session?.sessionNumber)
          });
        } else if (this.weekSummary?.lastSessionInWeek) {
          sessionArray.push(this.weekSummary?.lastSessionInWeek)
        }

        const groupId = this.route.snapshot.params['memberId'] ? this.selectedUserGroupId : this.groupId;
        const filters = {
          roles: role,
          sessions: sessionArray,
          ...(groupId && groupId !== -1 ? { groups: [groupId] } : {})
        };

        if (this.role === roles['participant']) {
          delete filters?.roles
        }

        const payload = {
          filters,
          sortColumn: "order",
          sortOrder: sortOrderMap.desc,
          onlySessions: true,
          ...(pagination ? pagination : {pageNumber: 1})
        }

        if (JSON.stringify(this.payload) !== JSON.stringify(payload)) {
          this.store.dispatch(FetchResourceListRequest({payload}));

          this.payload = payload;
        }

      }
    }

  }

  getNext() {
    this.paginationRelatedLoading = true;

    if (this.resourcesData.hasNext) {
      const pagination = {
        pageNumber: this.resourcesData.pageNumber + 1
      }

      this.fetchResourceList(pagination);
    }
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
